import React from 'react'

import Fab from '@mui/material/Fab'
import { Text } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import useWindowSize, { isTypeDesktop } from '@/hooks/use-window-size'

import styles from './styles.module.scss'

interface Props {
    onClick?: () => void
}

const ClearSectionsButton: React.FC<Props> = ({ onClick }) => {
    const { type } = useWindowSize()
    const isDesktop = isTypeDesktop(type)

    return (
        <Fab
            variant="extended"
            disableRipple
            classes={{
                root: classNames(styles.fabRoot, {
                    [styles.mobile]: !isDesktop,
                }),
            }}
            sx={{ boxShadow: 6, ':active': { boxShadow: 6 } }}
            onClick={onClick}
            data-testid="clear-section"
        >
            <Text
                altFont
                className={classNames(styles.fabText, { [styles.desktop]: isDesktop })}
                size={isDesktop ? 'lg' : 'md'}
            >
                Clear sections
            </Text>
        </Fab>
    )
}

export default ClearSectionsButton
